module.exports = __webpack_public_path__ + "img/step_img3.d65e979c.png";